import { Label } from "@/components/ui/label";
import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";

interface PaymentMethodSelectProps {
  paymentMethod: string;
  setPaymentMethod: (method: string) => void;
}

export function PaymentMethodSelect({ paymentMethod, setPaymentMethod }: PaymentMethodSelectProps) {
  return (
    <div>
      <Label>Forma de Pagamento</Label>
      <RadioGroup 
        value={paymentMethod} 
        onValueChange={setPaymentMethod}
        className="flex gap-4 mt-2"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="dinheiro" id="dinheiro" />
          <Label htmlFor="dinheiro">Dinheiro</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="pix" id="pix" />
          <Label htmlFor="pix">PIX</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="cartao" id="cartao" />
          <Label htmlFor="cartao">Cartão</Label>
        </div>
        <div className="flex items-center space-x-2">
          <RadioGroupItem value="transferencia" id="transferencia" />
          <Label htmlFor="transferencia">Transferência</Label>
        </div>
      </RadioGroup>
    </div>
  );
}